export default "__VITE_ASSET__tgItkVM6JTrfm2CiQnzY5g__ 220w";